// @flow

import React from 'react';
import { colors } from '../../style'

type Props = {
  hovered: boolean,
  width: number,
  height: number,
  className: string,
}

function ViewIcon({ hovered, width, height, className }: Props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 33" width={width} height={height} className={className}>
      <g fill="none" fillRule="evenodd">
        <path stroke={hovered ? colors.red : colors.black} strokeWidth="2" d="M46.147 16.146c0 8.365-6.782 15.146-15.146 15.146s-15.143-6.78-15.143-15.146S22.637 1 31 1s15.147 6.78 15.147 15.146z" strokeLinecap="round" strokeLinejoin="round"/>
        <path fill={hovered ? colors.red : colors.black} d="M35.97 11.18L31 16.147V9.12c-3.88 0-7.026 3.146-7.026 7.026S27.12 23.17 31 23.17s7.025-3.145 7.025-7.024c0-1.94-.785-3.694-2.055-4.965"/>
        <path stroke={hovered ? colors.red : colors.black} strokeWidth="2" d="M61 16.146S47.568 31.292 31 31.292c-16.568 0-30-15.146-30-15.146S14.432 1 31 1c16.568 0 30 15.146 30 15.146z" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  )
}

export default ViewIcon;



// WEBPACK FOOTER //
// ./src/components/Book/ViewIcon.js